import { takeLatest } from 'redux-saga/effects';
import {
    BUNDLE_PAYER_LIST_REQUEST,
    DOWNLOAD_BUNDLE_REQUEST,
    DOWNLOAD_TASK_STATUS_REQUEST,
    FETCH_BUNDLES_REQUEST,
} from '../../redux/modules/bundles/bundles-actions';
import fetchBundleListWorker from './bundlesWorkerSaga';
import { commonGetWorkerSaga } from '../commonSaga/commonWorkerSaga';

export function* fetchBundlesListWatcher() {
    yield takeLatest(FETCH_BUNDLES_REQUEST, fetchBundleListWorker);
}

export function* downloadClaimsBundleWatcher() {
    yield takeLatest(DOWNLOAD_BUNDLE_REQUEST, commonGetWorkerSaga);
}

export function* fetchBundlePayersWatcher() {
    yield takeLatest(BUNDLE_PAYER_LIST_REQUEST, commonGetWorkerSaga);
}

export function* getDownloadTaskStatusRequest() {
    yield takeLatest(DOWNLOAD_TASK_STATUS_REQUEST, commonGetWorkerSaga);
}
